/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import { PageInfo } from "./PageInfo";
import { PaymentServiceProviderView } from "./PaymentServiceProviderView";
import * as t from "io-ts";

// required attributes
const PaymentServiceProvidersViewR = t.interface({
  page_info: PageInfo,

  payment_service_providers: t.readonlyArray(
    PaymentServiceProviderView,
    "array of PaymentServiceProviderView"
  )
});

// optional attributes
const PaymentServiceProvidersViewO = t.partial({});

export const PaymentServiceProvidersView = t.intersection(
  [PaymentServiceProvidersViewR, PaymentServiceProvidersViewO],
  "PaymentServiceProvidersView"
);

export type PaymentServiceProvidersView = t.TypeOf<
  typeof PaymentServiceProvidersView
>;
